import React, { useEffect, useState } from "react";
import PaulService from "../../services/paul";
import { getDomain, DEFAULT_ENV } from "../../constants";
import EnvironmentSelector from "../options/environment_selector";
import InvisibleRequest from "../options/invisible_request";

const company = require("./company.json");
const person = require("./person.json");

const paramsByEnv = {
  development: {
    userId: "usr_sta_JT7k1DlQT3Tf",
    productId: "prod_val_SkBPP8V0bZy8",
    policyOwnerKind: "person",
    invisible: true,
    publicApiToken: "WT3V6JBELkfqEij1hvXEsSGU",
  },
  staging: {
    userId: "usr_sta_JT7k1DlQT3Tf",
    productId: "prod_val_SkBPP8V0bZy8",
    policyOwnerKind: "person",
    invisible: true,
    publicApiToken: "WT3V6JBELkfqEij1hvXEsSGU",
  },
  validation: {
    userId: "",
    productId: "",
    policyOwnerKind: "",
    invisible: true,
    publicApiToken: "",
  },
  production: {
    userId: "",
    productId: "",
    policyOwnerKind: "person",
    invisible: true,
    publicApiToken: "",
  },
};

const SocoDemo = () => {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [userId, setUserID] = useState("");
  const [productId, setProductID] = useState("");
  const [policyOwnerKind, setPolicyOwnerKind] = useState("person");
  const [environment, setEnvironment] = useState(DEFAULT_ENV);
  const [invisible, setInvisible] = useState(true);
  const [publicApiToken, setPublicApiToken] = useState("");
  const domain = getDomain(environment);

  const changeEnvironment = (env) => {
    setEnvironment(env);
    setUserID(paramsByEnv[env].userId);
    setProductID(paramsByEnv[env].productId);
    setPolicyOwnerKind(paramsByEnv[env].policyOwnerKind);
    setPublicApiToken(paramsByEnv[env].publicApiToken);
  };

  useEffect(() => {
    changeEnvironment(DEFAULT_ENV);
  }, []);

  const createEmbed = async (e) => {
    e.preventDefault();
    setLoading(true);
    const paulService = new PaulService(environment, true, publicApiToken);
    const { id } = await paulService.createCR(
      environment,
      userId,
      productId,
      policyOwnerKind === "company" ? company : person,
      invisible
    );
    const token = await paulService.createRequestUserToken(
      environment,
      userId,
      id
    );
    setToken(token);
    setLoading(false);
  };

  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }
  return (
    <div className="App" style={{ height: "100%" }}>
      <h1>Soco Demo</h1>
      {!token && (
        <>
          <EnvironmentSelector
            value={environment}
            onChange={(env) => changeEnvironment(env)}
          />
          <InvisibleRequest onChange={(invisible) => setInvisible(invisible)} />
          <div>
            <label style={{ marginRight: "10px" }}>User ID:</label>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserID(e.target.value)}
            />
          </div>
          <div>
            <label style={{ marginRight: "10px" }}>Public API Token:</label>
            <input
              type="text"
              value={publicApiToken}
              onChange={(e) => setPublicApiToken(e.target.value)}
            />
          </div>
          <div>
            <label style={{ marginRight: "10px" }}>Product ID:</label>
            <input
              type="text"
              value={productId}
              onChange={(e) => setProductID(e.target.value)}
            />
          </div>
          <div>
            <label style={{ marginRight: "10px" }}>Policy owner kind:</label>
            <select
              onChange={(e) => {
                setPolicyOwnerKind(e.target.value);
              }}
            >
              <option value="person">Person</option>
              <option value="company">Company</option>
            </select>
          </div>
          <button onClick={createEmbed} style={{ marginTop: "10px" }}>
            Create request
          </button>
        </>
      )}
      {token && (
        <div>
          <h3>Embed :</h3>
          <div
            className="container"
            style={{ width: "1024px", height: "768px", margin: "0 auto" }}
          >
            <iframe
              title="Insurgate"
              src={`${domain}?rut=${token}&theme=soco&invisible=${invisible}`}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SocoDemo;
